<template>
  <div id="main" :style="'background-color: ' + siteConfiguration.body_background_color"
    class="body-custom">
    <LayoutCustomNavbar v-if="siteConfiguration.navbar_enabled"
      :siteConfiguration="siteConfiguration"
    />

    <router-view :siteConfiguration="siteConfiguration" />

    <button class="btn btn-primary btn-circle" id="to-top">
      <i class="fa fa-angle-up"></i>
    </button>

    <LayoutCustomFooter v-if="siteConfiguration.footer_enabled"
      :siteConfiguration="siteConfiguration"
    />
  </div>
</template>

<script>
import SiteConfigurationService from '../services/SiteConfigurationService'
import LayoutCustomNavbar from './LayoutCustomNavbar.vue'
import LayoutCustomFooter from './LayoutCustomFooter.vue'
import Env from '../env'

export default {
  name: 'AppLayout',
  components: {
    LayoutCustomNavbar,
    LayoutCustomFooter
  },
  mixins: [Env],
  data: function () {
    return {
      siteConfiguration: {},
      user: null
    }
  },
  head: {
    title: function () {
      return {
        inner: this.siteConfiguration.site_title || 'Please wait...',
        separator: ' ',
        complement: ' '
      }
    },
    link: function () {
      return this.siteConfiguration.icon_url ? [
        { rel: 'shortcut icon', href: this.siteConfiguration.icon_url, sizes: '16x16', type: 'image/x-icon' },
        { rel: 'icon', href: this.siteConfiguration.icon_url, sizes: '16x16', type: 'image/x-icon' },
        { rel: 'canonical', href: `https://${this.siteConfiguration.url_site + this.$router.currentRoute.fullPath}` }
      ] : []
    },
    meta: function () {
      let tags = [
        {
          name: 'description',
          content: 'We will help you to find the best events to spend an unforgettable moment',
          id: 'description-tag'
        }
      ]

      if (!this.runningOnProduction()) {
        tags.push({
          name: 'robots',
          content: 'noimageindex, nofollow, nosnippet',
          id: 'robots-tag'
        })
      }

      return tags
    }
  },
  created () {
    this.loadSiteConfiguration()

    // Set custom styles
    let body = document.querySelector('body')
    body.classList.add('body-custom')
  },
  methods: {
    loadSiteConfiguration () {
      var self = this
      var hostname = this.$route.params['domain_name'] || window.location.hostname

      SiteConfigurationService.getSiteConfigurationByUrl(hostname).then((response) => {
        self.siteConfiguration = response.data
        self.$emit('updateHead')
      })
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import '../assets/scss/custom_styles.scss';
</style>
